import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { categories } from '@/mocks/categories';
import TopicCard from '@/components/feature/TopicCard';

function categoryName(slug: string) {
  const found = categories.find((cat) => cat.slug === slug);
  return found ? found.name : '';
}

export default function FreshFeed() {
  const main = topics[0];
  const sideList = topics.slice(1, 5);

  return (
    <section className="border-b border-background-200 bg-background-50 py-12 md:py-16" aria-labelledby="fresh-heading">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-800">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-fire-line text-sm" />
              </span>
              刚落地的料
            </span>
            <h2 id="fresh-heading" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日鲜料
            </h2>
          </div>
          <Link
            to="/breaking"
            className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-primary-700 transition-colors hover:text-primary-600"
          >
            查看全部突发
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <Link to={`/topic/${main.slug}`} className="relative block h-64 w-full overflow-hidden md:h-80">
                <img
                  src={main.cover}
                  alt={main.coverAlt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
                  {main.tag}
                </span>
              </Link>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <Link to={`/category/${main.categorySlug}`} className="cursor-pointer text-primary-700 hover:text-primary-600">
                    {categoryName(main.categorySlug)}
                  </Link>
                  <span>{main.timeAgo}</span>
                  <span className="flex items-center gap-1">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-eye-line" />
                    </span>
                    {main.readCount}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  <Link to={`/topic/${main.slug}`} className="cursor-pointer transition-colors hover:text-primary-700">
                    {main.title}
                  </Link>
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">{main.summary}</p>
                <div className="mt-5 flex flex-wrap items-center gap-2 border-t border-background-200 pt-4">
                  <span className="text-xs text-foreground-500">最新进展</span>
                  <span className="h-1 w-1 rounded-full bg-foreground-300" />
                  <span className="line-clamp-1 text-xs text-foreground-700">{main.timeline[main.timeline.length - 1].text}</span>
                </div>
              </div>
            </article>
          </div>

          <div className="flex flex-col gap-4 lg:col-span-5">
            {sideList.map((topic) => (
              <TopicCard key={topic.slug} topic={topic} categoryName={categoryName(topic.categorySlug)} layout="horizontal" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}